import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Chip, Grid, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

function CarbonVerification(props) {

  const renderStatus = (status) => {
    if('Draft' === status) {
      return <Chip label="Not Submitted" />
    }

    return <Chip label="Not Submitted" />
  }

  const renderResult = (result) => {
    return ' - '
  }

  const renderContent = () => {
    if (!props.isEnabled) {
      return <Typography>This section will be available, once the parcel passes an applicability check</Typography>
    }

    return (
      <TableContainer>
        <Table sx={{'& td, & th': {fontWeight: 'bold', border: 'none', '&:first-of-type': {fontSize: '16px'}}, '& th': {fontSize: '18px'}}}>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Result</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>Emissions ({props.year})</TableCell>
              <TableCell>{renderStatus()}</TableCell>
              <TableCell>{renderResult()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Soil Organic Carbon</TableCell>
              <TableCell>{renderStatus()}</TableCell>
              <TableCell>{renderResult()}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Biomass Management</TableCell>
              <TableCell>{renderStatus()}</TableCell>
              <TableCell>{renderResult()}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    )
  }

  return (
    <>
      <Stack direction="row">
        <Typography color="primary" variant="h5" sx={{ mb: '20px' }} fontWeight={"bold"}>Verification</Typography>
      </Stack>
      {renderContent()}
    </>
  )
}

export default CarbonVerification;